import { type FC } from 'react';

import { specContractList } from '@/common/constants/contract';

import { NextContractIn } from './NextContractIn';

const NextContractInBlock: FC = () => {
  return specContractList.map((kind) => (
    <NextContractIn key={`${kind}-next-in`} kind={kind} />
  ));
};

export default NextContractInBlock;
